import Render from './Render';
import { CenteredIcon } from '../../../components/Table/CenteredIcon';
import React from 'react';

class ActiveIcon extends Render {
  render = (active: boolean) => {
    const bgColor = active ? 'bg-success' : 'bg-alert';
    const icon = active ? 'check' : 'close';
    return {
      props: {className: bgColor},
      children: <CenteredIcon
        icon={icon}
        style={{
          backgroundColor: bgColor,
          color: '#ffffff'
        }} iconSize={'16px'}
      />
    };
  };
}

export default ActiveIcon;
